import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const CourtBuildingIcon = createIcon({
  displayName: 'CourtBuildingIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M6 13.5v-2l1.06581e-14 1.50996e-07c-8.33927e-08-.552285.447715-1 1-1h10l-4.37114e-08 1.77636e-15c.552285-2.41411e-08 1 .447715 1 1v2"></path>
        <line x1="10" x2="10" y1="13.5" y2="18"></line>
        <line x1="7" x2="7" y1="18" y2="13.5"></line>
        <line x1="14" x2="14" y1="13.5" y2="18"></line>
        <line x1="17" x2="17" y1="18" y2="13.5"></line>
        <path d="M15.967 10.5v-6.01005e-08c-1.77636e-15-2.19091-1.77609-3.967-3.967-3.967 -2.19091 8.88178e-16-3.967 1.77609-3.967 3.967 0 3.94086e-08 1.77636e-15 7.88172e-08 1.77636e-15 1.18226e-07"></path>
        <path d="M20 18v-3.5 0c0-.552285-.447715-1-1-1h-14l-4.37114e-08 1.77636e-15c-.552285 2.41411e-08-1 .447715-1 1 0 0 0 0 0 0v3.5"></path>
        <path d="M21 21v-1.586l2.28059e-08.000213569c0-.265195-.10534-.51953-.292849-.707063l-.707151-.707151h-16l-.707.707 8.42765e-08-8.4251e-08c-.187549.187493-.292943.441805-.293.707v1.586"></path>
        <line x1="22" x2="2" y1="21" y2="21"></line>
        <path d="M12 6.5v-4l5.32907e-15 7.54979e-08c-4.16963e-08-.276142.223858-.5.5-.5h3l-2.18557e-08 4.44089e-16c.276142-1.20706e-08.5.223858.5.5v1.418 -4.44089e-16c0 .276142-.223858.5-.5.5h-3.5"></path>
      </g>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})

const CourtBuilding: FC<IconProps> = (props) => {
  return <CustomIcon as={CourtBuildingIcon} {...props} />
}

export default memo(CourtBuilding)
